/**
 * **「숫자로 읽히는가」 한 곳** — 의존성이 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지).
 *
 * 읽을 수 없는 입력이 숫자 축으로 흘러가는 것을 막는 관문이고, 그 관문이 하나여야 하는 이유가 있다.
 * 같은 판정이 두 곳에 있으면 **규칙이 조용히 갈린다**: 실제로 그랬다 — 콜팝 축은 공백뿐인 문자열을
 * `null` 로 읽고 플레이스 축은 `Number('  ') === 0` 을 그대로 받아 **0** 으로 읽었다. 같은 화면의
 * 좌표 칸이 어느 파일을 지나느냐에 따라 「없음」과 「0」으로 갈리는 상태였다.
 */

/**
 * 숫자로 읽히면 숫자, 아니면 `null`.
 *
 * - 사람이 친 매장 ID(`S260001287`)·매장명·URL 질의(`?agencyCd=abc`)는 `Number()` 로 **`NaN`** 이 된다.
 *   `NaN` 은 `null` 도 `''` 도 아니라 질의 정리에 걸리지 않고, 받는 쪽에서 400 이 되며, `!NaN` 이 참이라
 *   「값이 없다」로도 읽힌다 — 한 값이 **있다와 없다 양쪽으로 행세**한다. 여기서 `null` 로 끝낸다.
 * - 공백뿐인 문자열도 `null` 이다. `Number('  ')` 는 `0` 이라 그대로 두면 **0 번 대상**을 지목하거나
 *   좌표 `0`(적도·본초자오선)을 저장한 것이 된다.
 * - `Infinity`·`NaN` 도 `null` 이다(유한한 값만 숫자로 친다).
 */
export function toNumberOrNull(value) {
  if (value == null) return null
  const text = typeof value === 'string' ? value.trim() : value
  if (text === '') return null
  const number = Number(text)

  return Number.isFinite(number) ? number : null
}
